import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs';

@Injectable()
export class PageLoaderService {
    private pageLoading = new BehaviorSubject<{isLoading: boolean; message?: string}>({
        isLoading: false,
        message: undefined,
    });

    public get isPageLoading(): Observable<{}>{
        return this.pageLoading.asObservable(); 
    }

    public showPageLoader(message?: string): void {
        this.pageLoading.next({ isLoading: true, message });
    }

    public hidePageLoader(): void {
        this.pageLoading.next({ isLoading: false, message: undefined });
    }
}